module.exports = __webpack_public_path__ + "static/img/user_avatar01.0aade94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_avatar01.png
// module id = EF0+
// module chunks = 1